export function toMonthlyExpenseCreatePayload(data: Record<string, unknown>): Record<string, unknown> {
  const { recordNo: _recordNo, id: _id, ...rest } = data;
  return rest;
}
